import amplitude, { type AmplitudeClient, type Config } from "amplitude-js";

import env, { envName, Environments } from "@/environment";
import {
  configureAmplitudeInstance,
  LoggerConfig as _LoggerConfig,
  type LoggerType,
  type LoggerOptions,
  LoggerTransports,
} from "@north-beam/nb-client-side/analytics";

import { type User } from "../user";

export * from "./bugsnag";

// ------------------------------------ Will Be Deprecated (START) ----------------------------- //
const configured = configureAmplitudeInstance<
  User,
  typeof amplitude,
  Config,
  amplitude.Identify,
  AmplitudeClient["identify"]
>({
  amplitude,
  apiKey: env.amplitudeApiKey,
  getInstance: () => amplitude.getInstance(),
});

configured.initialize();

export const logEvent = configured.logEvent;
export const prettyLogEvent = configured.prettyLogEvent;
export const init = configured.initialize;
export const identify = configured.identifyWeb;
// ------------------------------------ Will Be Deprecated (END) ------------------------------- //
const AmplitudeConfig = {
  apiKey: env.amplitudeApiKey,
  Identify: amplitude.Identify,
  getInstance: () => amplitude.getInstance(),
} as const;

const AmplitudeProdLoggingEnabled = [undefined, true].includes(
  env.emitLogEventsToAmplitude,
)
  ? [LoggerTransports.AMPLITUDE]
  : [];

const DevEmitAmplitudeEventsToBrowser =
  env.emitLogEventsToBrowser === undefined ? true : env.emitLogEventsToBrowser;

export const loggerConfig = new _LoggerConfig({
  defaultName: "frontend",
  amplitude: AmplitudeConfig,
  environment: process.env.NODE_ENV === "test" ? "test" : envName,
  environments: [...Environments, "test"] as const,
  nodeEnvironment: process.env.NODE_ENV,
  module: "nb-frontend",
  transports: {
    prod: AmplitudeProdLoggingEnabled,
    "prod-staging": AmplitudeProdLoggingEnabled,
    "prod-canary-cloudrun": AmplitudeProdLoggingEnabled,
    "prod-alt": AmplitudeProdLoggingEnabled,
    dev: [LoggerTransports.BROWSER],
    "prod-local": [LoggerTransports.BROWSER],
    "prod-local-proxy": [LoggerTransports.BROWSER],
    "dev-local": [LoggerTransports.BROWSER],
    "dev-local-proxy": [LoggerTransports.BROWSER],
    test: [],
  },
  prettyLog: {
    prod: false,
    "prod-staging": false,
    "prod-canary-cloudrun": false,
    "prod-alt": false,
    dev: true,
    "prod-local": true,
    "prod-local-proxy": true,
    "dev-local": true,
    "dev-local-proxy": true,
    test: false,
  },
  /* In development environments, by default, events will be logged to the browser console, for
     debugging purposes.  This can be turned off with the environment flag
     emitAmplitudeEventsToBrowser.  Whether or not the event is emitted to Amplitude is determined
     by the 'transports' option. */
  emitEventsToBrowser: {
    prod: false,
    "prod-staging": false,
    "prod-canary-cloudrun": false,
    "prod-alt": false,
    dev: DevEmitAmplitudeEventsToBrowser,
    "prod-local": DevEmitAmplitudeEventsToBrowser,
    "prod-local-proxy": DevEmitAmplitudeEventsToBrowser,
    "dev-local": DevEmitAmplitudeEventsToBrowser,
    "dev-local-proxy": DevEmitAmplitudeEventsToBrowser,
    test: false,
  },
});

export type Logger<O extends LoggerOptions> = LoggerType<
  typeof loggerConfig,
  O
>;
